export default __webpack_public_path__ + "static/media/agile-polly-logo-white.7d74fbc2.svg";